import { ReactNode } from 'react';
import { Button, Flex, Text } from '@optiaxiom/react';

type EmptyStateMessageProps = {
  message: string;
  subMessage?: string;
  icon?: ReactNode;
  action?: {
    label: string;
    onClick: () => void;
    icon?: ReactNode;
    loading?: boolean;
    disabled?: boolean;
  };
};

export function EmptyStateMessage({ message, subMessage, icon, action }: EmptyStateMessageProps) {
  return (
    <Flex
      flexDirection="column"
      alignItems="start"
      justifyContent="center"
      py="24"
      gap="8"
      bg="bg.secondary"
      rounded="md"
    >
      {icon && <Flex mb="8">{icon}</Flex>}
      <Text color="fg.secondary">{message}</Text>
      {subMessage && (
        <Text fontSize="sm" color="fg.secondary">
          {subMessage}
        </Text>
      )}
      {action && (
        <Button
          appearance="primary"
          icon={action.icon}
          onClick={action.onClick}
          loading={action.loading}
          disabled={action.disabled}
          mt="8"
        >
          {action.label}
        </Button>
      )}
    </Flex>
  );
}
